<template>
  <div class="banding_bank">
    <van-row>
      <van-col span="22" offset="1">
        <van-col span="24" class="banding_bank_bg" v-for="(v,i) in list" :key="i">
          <!--          <van-col span="4" class="banding_bank_img">-->
          <!--            <van-image width="2.3rem" height="2.3rem" round :src="v.img"/>-->
          <!--          </van-col>-->
          <van-col span="20" offset="1" class="banding_bank_center">
            <van-col span="24" class="banding_bank_center_name">
              <van-tag type="danger" size="medium" v-if="v.choose">{{ $t('column.default') }}</van-tag>
              {{ v.account }}
              <van-icon name="edit" @click="account_edit(i)"/>
            </van-col>
            <van-col span="24" class="banding_bank_center_val"><span>{{ $t('column.account') }}：{{ v.account_number | hideAccountNumber }}</span></van-col>
          </van-col>
          <van-col span="3" class="banding_bank_btn" @click="checked_btn(i)">
            <van-icon name="checked" size="22" color="#9152F8" v-if="v.choose"/>
            <van-icon name="circle" size="22" v-else/>
          </van-col>
        </van-col>
        <van-col span="20" offset="2">
          <van-button round color="#7232dd" class="banding_bank_sheet_btn" block  @click="account_edit('-1')">{{ $t('column.add_account') }}</van-button>
        </van-col>
      </van-col>
    </van-row>
    <van-action-sheet v-model="show" :title="$t('column.edit_account')" style="height: 80%">
      <van-row>
        <van-col span="22" offset="1" class="banding_bank_sheet">
          <van-field v-model="from.name" :label="$t('column.Account_name')" :placeholder="$t('Tips.enter_account_name')" style="border-bottom: 1px solid #efefef;"/>
          <van-field v-model="from.account_name" :label="$t('column.alipay_name')" :placeholder="$t('placeholder.Please_enter_account_name')" style="border-bottom: 1px solid #efefef;"/>
          <van-field v-model="from.account" :label="$t('column.alipay_account')"  :placeholder="$t('placeholder.Please_enter_account')" style="border-bottom: 1px solid #efefef;"/>
          <van-button round color="#7232dd" class="banding_bank_sheet_btn" block @click="banding_bank_btn">{{ $t('btn.confirm_binding') }}</van-button>
        </van-col>
      </van-row>
    </van-action-sheet>
  </div>
</template>

<script>
  import Toast from "vant/lib/toast"
  import axios from 'axios'

  export default {
    filters: {
      hideAccountNumber(str) {
        if (str && str.length > 4) {
          return `****` + str.slice(str.length - 4)
        }else{
          return str
        }
      }
    },
    data() {
      return {
        index: 0,
        show: false,
        list: [],
        from: {
          id: undefined,
          name: undefined,
          account: undefined,
          account_name: undefined,
        },
      }
    },
    created: function () {
      document.title = this.$t('title.bangding_bank')
      this.initData()
    },
    methods: {
      checked_btn(index) {
        // 默认选中
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=bank&act=banding_bank_checked", {
          params: {
            token: token,
            id: this.list[index].id
          }
        }).then(res => {
          console.log(res.data)
          if (res.data.status === 1) {
            for(let i= 0; i < this.list.length; i ++) {
              this.list[i].choose = i == index ? 1 : 0
            }
          }else{
            Toast(res.data.error)
          }
        })
      },
      account_edit(i) {
        if (i === '-1') {
          this.index = i
          this.from = {
            id: undefined,
            name: undefined,
            account: undefined,
            account_name: undefined,
          }
        }else{
          this.index = i
          this.from = {
            id: this.list[i].id,
            name: this.list[i].account,
            account: this.list[i].account_number,
            account_name: this.list[i].name,
          }
        }

        this.show = true
      },
      banding_bank_btn() {
        // 绑定账户
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=bank&act=banding_bank", {
          params: {
            token: token,
            id: this.from.id,
            account_number: this.from.account,
            name: this.from.name,
            account_name: this.from.account_name
          }
        }).then(res => {
          console.log(res.data)
          Toast(res.data.error)
          if (res.data.status === 1) {
            this.initData()
            this.show = false
          }
        })
      },
      initData: function () {
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=bank&act=banding_bank_list", {
          params: {
            token: token,
          }
        }).then(res => {
          console.log(res.data)
          this.list = res.data.data
        })
      }
    }
  }
</script>
<style>
  .banding_bank_bg{background: #ffffff;margin-top: 1rem;border-radius: 0.5rem;}
  .banding_bank_img{height: 5rem;line-height: 5rem;text-align: center;padding-top:0.7rem}
  .banding_bank_center{height: 5rem;line-height: 5rem;}
  .banding_bank_center_name{height: 2rem;line-height: 3rem;color: #171717;font-size: 0.9rem;}
  .banding_bank_center_name .van-icon{margin-left: 1rem;}
  .banding_bank_center_name .van-tag{font-size: 0.5rem;}
  .banding_bank_center_val{height: 2rem;line-height: 2.5rem;font-size: 0.7rem;color:#666beb;}
  .banding_bank_center_val span{background: #ebedfc;padding:0.2rem 0.5rem;}
  .banding_bank_btn{height: 5rem;line-height: 5rem;color: #d6d6d9;text-align: center}
  .banding_bank{background: #f7f7f7;width: 100%;height: 100vh;}
  .banding_bank_sheet{margin-top:1rem;}
  .banding_bank_sheet_btn{margin-top:3rem;}
</style>



// WEBPACK FOOTER //
// src/components/banding_bank.vue